var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "p-0", attrs: { cols: "12", md: "8" } },
            [
              _c(
                "b-card",
                { staticClass: "card-main-article" },
                [
                  _c(
                    "b-breadcrumb",
                    { staticClass: "m-0" },
                    [
                      _c(
                        "b-link",
                        {
                          on: {
                            click: function($event) {
                              return _vm.routeToName("home")
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-less-than" }),
                          _vm._v(
                            "\n                        Home\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-container",
                    { staticClass: "p-4" },
                    [
                      _c("b-card-title", { attrs: { "title-tag": "h3" } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.linkTitle) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.linkContent != null && _vm.linkContent != ""
                        ? _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.linkContent) }
                          })
                        : _c(
                            "b-alert",
                            { attrs: { show: "", variant: "warning" } },
                            [
                              _vm._v(
                                "\n                        This content is missing or empty! Please contact the site administrator.\n                    "
                              )
                            ]
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "p-0", attrs: { cols: "12", md: "4" } },
            [
              _c(
                "b-card",
                { staticClass: "card-sidebar", attrs: { "no-body": "" } },
                [
                  _vm.linkCardTitle == "News"
                    ? _c("news-content-card", {
                        attrs: {
                          "news-card-title": _vm.linkCardTitle,
                          "news-card-bundle": _vm.linkCardBundle
                        }
                      })
                    : _c("links-content-card", {
                        attrs: {
                          "link-card-title": _vm.linkCardTitle,
                          "link-card-bundle": _vm.linkCardBundle
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce44b3a4", { render: render, staticRenderFns: staticRenderFns })
  }
}